<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="70" :isOpen="isOpen" :closeCompleteAction="closeCompleteAction">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeCompleteAction" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding: 0 12px; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">포지션 설정</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px;">주로 뛰었던 포지션이나<br>가장 자신있는 포지션을 선택할 수 있습니다.</div>
                </div>
                <div style="margin-top: 40px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 24px; line-height: 24px;">공격</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setPosition(each)" :class="position === each ? 'active' : ''" v-for="each, i in foward" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
                <div style="margin-top: 16px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; line-height: 24px;">미드필더</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setPosition(each)" :class="position === each ? 'active' : ''" v-for="each, i in midfielder" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
                <div style="margin-top: 16px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; line-height: 24px;">수비</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setPosition(each)" :class="position === each ? 'active' : ''" v-for="each, i in defence" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            {{ each }}
                        </div>
                    </div>
                </div>
                <div style="margin-top: 16px;">
                    <div style="font-weight: 500; font-size: 14px; margin-bottom: 4px; line-height: 24px;">골키퍼</div>
                    <div style="display: flex; flex-wrap: wrap; gap: 12px;">
                        <div @click="setPosition('GK')" :class="position === 'GK' ? 'active' : ''" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                            GK
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="position !== ''" class="save_btn_active">저장하기</div>
                <div v-else class="save_btn_unactive">저장하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode from '../../ResponseCode'

export default {
    name: 'SettingPosition',
    components: {CommonPopupFrame},
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            foward: ['CF', 'SS', 'LWF', 'RWF'],
            midfielder: ['AM', 'CM', 'DM', 'LM', 'RM'],
            defence: ['CB', 'LB', 'RB', 'LWB', 'RWB'],
            position: ''
        }
    },
    methods: {
        setPosition(position) {
            this.position = position
        },
        async save() {
            this.$GlobalStore.showProgress()
            const formData = new FormData()
            formData.append('position', this.position)
            formData.append('is_direct_position', 1)

            const res = await this.$Axios.post('/api/position/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.position = ''
                this.$GlobalStore.hideProgress()
                this.closeCompleteAction(true)
            }
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.position = ''
            }
        }
    },
    created() {
        this.save = this.$Once(this.save)
    }
}
</script>

<style scoped>
.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 40px;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.active {
    background-color: #210f03;
    color: #fff;
}
</style>